import IconWithLabel from './IconWithLabel.vue';
export default IconWithLabel;
